<div
  #grid
  class="gr-canvas__grid"
  [class.gr-canvas__grid--flow]="scaledFromBase()"
  [class.gr-canvas__grid--empty]="!hasItems()"
  [style.min-block-size.px]="dragMinHeight()"
>
  @for (item of displayItems(); track item.id; let i = $index) {
    <gr-canvas-item
      [item]="item"
      [editing]="editing()"
      [placed]="!scaledFromBase()"
      [maxCols]="cols()"
      [minColSpan]="minColFor(item.kind, item.id)"
      [minRowSpan]="minRowFor(item.kind, item.id)"
      [displayColSpan]="effectiveColSpan(item)"
      [resizable]="!scaledFromBase()"
      [dragging]="isDragged(item.id)"
      [class.gr-canvas-item--ghost]="isGhost(item.id)"
      [floatRect]="floatRectFor(item.id)"
      (dragStart)="onItemDragStart($event)"
      (editRequested)="editRequested.emit($event)"
      (removeRequested)="removeRequested.emit($event)"
      (resized)="resized.emit($event)"
    >
      @let tpl = templateFor(item.kind);
      @if (tpl) {
        <ng-container *ngTemplateOutlet="tpl; context: contextFor(item, i)" />
      } @else {
        <div class="gr-canvas__missing flex h-full items-center justify-center gap-2" role="status">
          <span class="material-icons-outlined" aria-hidden="true">help_outline</span>
          <span>No renderer registered for kind "{{ item.kind }}"</span>
        </div>
      }
    </gr-canvas-item>
  }

  @if (placeholder(); as ph) {
    <div
      class="gr-canvas__placeholder"
      aria-hidden="true"
      [style.grid-column]="(ph.x ?? 0) + 1 + ' / span ' + ph.colSpan"
      [style.grid-row]="(ph.y ?? 0) + 1 + ' / span ' + ph.rowSpan"
    ></div>
  }

  @if (phantom(); as ph) {
    <div
      class="gr-canvas__phantom"
      aria-hidden="true"
      [style.grid-column]="(ph.x ?? 0) + 1 + ' / span ' + ph.colSpan"
      [style.grid-row]="(ph.y ?? 0) + 1 + ' / span ' + ph.rowSpan"
    ></div>
  }

  @if (editorPadRow(); as padRow) {
    <div
      class="gr-canvas__editor-pad"
      aria-hidden="true"
      [style.grid-column]="'1 / -1'"
      [style.grid-row]="padRow"
    ></div>
  }

  @for (group of emptyRowGroups(); track group.startRow) {
    <div
      class="gr-canvas__empty-rows"
      [style.grid-column]="'1 / -1'"
      [style.grid-row]="(group.startRow + 1) + ' / span ' + group.count"
      aria-hidden="true"
    >
      <button
        type="button"
        class="gr-canvas__empty-rows-btn"
        (click)="deleteRowsRequested.emit(group)"
      >
        <span class="material-icons-outlined" aria-hidden="true">compress</span>
        <span>{{ group.count === 1 ? 'Remove 1 empty row' : 'Remove ' + group.count + ' empty rows' }}</span>
      </button>
    </div>
  }
</div>

@if (!hasItems()) {
  <div class="gr-canvas__empty-overlay" aria-hidden="true">
    <gr-empty-state
      [icon]="emptyIcon()"
      [description]="phantom() ? 'Release to drop your widget here.' : emptyLabel()"
      [fill]="true"
    />
  </div>
}
